export default __webpack_public_path__ + "static/media/email_invoices.8a6f5248.svg";